type DataResidencyResponseCodes = 'AU' | 'CA' | 'IN' | 'SG' | 'UK' | 'US' | 'EU';

export const getDataResidencyParam = (): DataResidencyResponseCodes | null => {
  const supportedDataResidencyCodes: DataResidencyResponseCodes[] = ['AU', 'CA', 'IN', 'SG', 'UK', 'US', 'EU'];

  const currentUrl = window.location.href;
  const url = new URL(currentUrl);
  const params = new URLSearchParams(url.search);
  const residencyParam = params.get('data_residency') || null;

  if (residencyParam === null) return null;
  if (!residencyParam) return null;
  const residencyParamUppercaseParsed = typeof residencyParam === 'string' ? residencyParam.toUpperCase() : '';

  const residencyIndexFound = supportedDataResidencyCodes.findIndex((item) => {
    return item === residencyParamUppercaseParsed;
  });

  return supportedDataResidencyCodes[residencyIndexFound] || null;
};
